export enum SSO_FLOW {
	REDIRECT_TO = 'redirectTo',
	REDIRECT_ATTEMPTS = 'redirectAttempts',
}
